import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cc6eadb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_md_alert = _resolveComponent("md-alert")!
  const _component_md_input_field = _resolveComponent("md-input-field")!
  const _component_md_button = _resolveComponent("md-button")!
  const _component_md_modal = _resolveComponent("md-modal")!

  return (_openBlock(), _createBlock(_component_md_modal, {
    ref: "modal",
    title: "Konversation starten",
    icon: "bolt"
  }, {
    default: _withCtx(() => [
      _createTextVNode(" Starte eine neue Konversation mit einem Kunden. Gebe dazu einen Namen und eine Telefonnummer ein."),
      _hoisted_1,
      _hoisted_2,
      _createTextVNode("Diese Funktion ist aktuell nur für WhatsApp verfügbar. ")
    ]),
    body: _withCtx(() => [
      _createVNode(_component_md_alert, {
        variant: "warning",
        icon: "warning"
      }, {
        default: _withCtx(() => [
          _createTextVNode("Du musst sicherstellen, dass der Kontakt einer Kommunikation mit deinem Unternehmen zugestimmt hat (Opt-In).")
        ]),
        _: 1
      }),
      _createVNode(_component_md_input_field, {
        variant: "outlined",
        modelValue: _ctx.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
        label: "Vor- und Nachname",
        ref: "nameInput",
        validator: _ctx.nameValidator,
        onKeypress: _withKeys(_ctx.startConversation, ["enter"])
      }, null, 8, ["modelValue", "validator", "onKeypress"]),
      _createVNode(_component_md_input_field, {
        variant: "outlined",
        modelValue: _ctx.phonenumber,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.phonenumber) = $event)),
        label: "Telefonnummer",
        ref: "phoneInput",
        validator: _ctx.phoneValidator,
        onKeypress: _withKeys(_ctx.startConversation, ["enter"])
      }, null, 8, ["modelValue", "validator", "onKeypress"])
    ]),
    actions: _withCtx(() => [
      _createVNode(_component_md_button, {
        variant: "text",
        grey: "",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _createTextVNode("Abbrechen")
        ]),
        _: 1
      }),
      _createVNode(_component_md_button, {
        variant: "filled",
        onClick: _ctx.startConversation
      }, {
        default: _withCtx(() => [
          _createTextVNode("Konversation starten")
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _: 1
  }, 512))
}